export default __webpack_public_path__ + "static/media/vaccine.dc2aa075.png";